// @ts-nocheck
import React from "react";
import { MenuDesplegable } from "./MenuDesplegable";
import { ACCESO_AREAS, ACCESO_AGENDA, ACCESO_USUARIOS, ACCESO_VER_ROLES, ACCESO_ALTA_USUARIOS } from "../../Contantes/Constantes";
import { AgendaIcono, AreasIcono } from "./IconosMenu";
import keycloak from "../../Auth/Keycloak";
import { Link } from "react-router-dom";
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

const itemSx = {
    mx: 0.5,
    borderRadius: 2,
    color: '#2d2d2d',
    transition: 'color 0.2s, background-color 0.2s',
    '&:hover': {
        backgroundColor: 'rgba(183, 18, 52, 0.06)',
        color: '#B71234',
    },
    '& .MuiListItemIcon-root': {
        color: 'inherit',
        minWidth: 44,
    },
};

export default function AreasItem({ openMenu, addMenuItemView }) {
    const opciones = [
        {
            link: '/areas',
            nombre: 'Gestión de Areas',
            rol: ACCESO_AREAS,
            view: 'areas'
        },
        {
            link: '/usuarios/alta',
            nombre: 'Alta de Usuarios',
            rol: ACCESO_ALTA_USUARIOS,
            view: 'usuarios'
        },
        {
            link: '/usuarios/gestion',
            nombre: 'Gestion de Usuarios',
            rol: ACCESO_USUARIOS,
            view: 'usuarios'
        },
        {
            link: '/usuarios/roles',
            nombre: 'Gestion de Roles',
            rol: ACCESO_VER_ROLES,
            view: 'roles'
        }
    ];

    return (
        <div>
            {(!keycloak.hasRole(ACCESO_USUARIOS) && !keycloak.hasRole(ACCESO_AREAS) && !keycloak.hasRole(ACCESO_VER_ROLES) && keycloak.hasRole(ACCESO_AGENDA)) ?
                <Link onClick={addMenuItemView} to="/agenda" style={{ textDecoration: 'none' }}>
                    <ListItem button key="agenda" sx={itemSx}>
                        <ListItemIcon>
                            <AgendaIcono />
                        </ListItemIcon>
                        <ListItemText primary="Agenda" />
                    </ListItem>
                </Link>
                :
                <MenuDesplegable openMenu={openMenu} addMenuItemView={addMenuItemView} icon={<AreasIcono />} modulo={'Areas'} opciones={opciones} />
            }
        </div>
    );
}
